module.exports = __webpack_public_path__ + "131d32b552454b6c847c9a9b9b2f13e1.png";